<template>
  <page-layout
    title="库存定价"
    tip="定价后的库存将会推送到销售管道"
    class="p-InventoryPricing"
    v-loading="loading"
    element-loading-text="请稍后..."
  >
    <div
      slot="title-right"
      class="pull-right"
    >
      <znl-button
        type="text"
        @click="() =>{ openMessage() }"
      >
        定价规则调整通知
      </znl-button>
      <znl-button
        type="text"
        @click="showCommonProblems = true"
      >
        常见问题
      </znl-button>
    </div>
    <header class="c-tradingcenter-search-header clearfix">
      <div class="c-tradingcenter-search-header-fl">
        <znl-input
          width="100px"
          :height="30"
          :border="true"
          placeholder="型号"
          v-model="Model"
          :clearable="true"
          @keydown.enter="
            () => {
              onBindData();
            }
          "
        >
        </znl-input>

        <znl-input
          width="64px"
          :height="30"
          :border="true"
          placeholder="￥未税价"
          class="header-marginleft"
          v-model="StandardPriceStart"
          :clearable="true"
          @keydown.enter="
            () => {
              onBindData();
            }
          "
        >
        </znl-input>
        <span class="input-center-text">至</span>
        <znl-input
          width="64px"
          :height="30"
          :border="true"
          placeholder="￥未税价"
          v-model="StandardPriceEnd"
          :clearable="true"
          @keydown.enter="
            () => {
              onBindData();
            }
          "
        >
        </znl-input>

        <znl-input
          form-type="select"
          :select-options="tieredPricings"
          placeholder="阶梯价方案"
          :border="true"
          :height="30"
          width="100px"
          class="header-marginleft"
          v-model="StepPlanGuid"
          :clearable="true"
          ref="selectinput"
          @change="changeHandler"
          @clear="changeHandler"
        >
        </znl-input>

        <znl-input
          form-type="select"
          :select-options="IsInvoiceOptions"
          placeholder="是否可开票"
          :border="true"
          :height="30"
          width="100px"
          class="header-marginleft"
          v-model="TaxRate"
          :clearable="true"
          ref="selectinput1"
          @change="IsInvoicechangeHandler"
          @clear="IsInvoicechangeHandler"
        >
        </znl-input>

        <znl-button
          :width="60"
          :height="30"
          class="header-marginleft"
          style-type="main"
          @click="
            () => {
              onBindData();
            }
          "
        >
          <i class="iconfont icon-sousuo"></i>
          搜索
        </znl-button>

        <znl-button
          :width="60"
          :height="30"
          class="header-marginleft"
          @click="clearParamsHandler"
        >
          <i class="iconfont icon-refresh"></i>
          重置
        </znl-button>

        <el-checkbox
          class="header-marginleft onlyabnormal"
          v-model="IsUnUsual"
          @change="
            () => {
              onBindData();
            }
          "
        >
          只看异常({{ UnUsualCount }})
        </el-checkbox>
      </div>

      <div class="pull-right">
        <znl-button
          :width="60"
          :height="30"
          class="header-marginleft"
          @click="
            () => {
              onBindData();
            }
          "
        >
          <i class="iconfont icon-refresh"></i>
          刷新
        </znl-button>
        <znl-button
          :width="80"
          :height="30"
          class="header-marginleft"
          @click="managingInventory"
          v-if="managingInventoryHandler"
        >
          <i class="iconfont icon-leftnav_stock"></i>
          管理库存
        </znl-button>

        <znl-button
          :width="100"
          :height="30"
          class="header-marginleft"
          :btns="printznlbtns"
          ref="znlbtn"
          @click="
            () => {
              $refs.znlbtn.unfoldSelete();
            }
          "
        >
          <i class="iconfont icon-change"></i>
          批量操作
        </znl-button>

        <znl-button
          :height="30"
          :width="60"
          style-type="main"
          class="header-marginleft"
          @click="() => saveHandler()"
        >
          <i class="iconfont icon-save"></i>
          保存
        </znl-button>
      </div>
    </header>

    <div class="p-InventoryPricing-grid-container">
      <grid
        :columns="columns"
        :datas="datas"
        type="edit"
        ref="grid"
        :selection="true"
        :total-count="totalCount"
        :page-size="pageSize"
        :page-index="pageIndex"
        :on-page-changed="onBindData"
        @onCellValueChanged="onCellValueChanged"
        domLayout="autoHeight"
      >
      </grid>
    </div>
    <select-pricing
      :visible.sync="showSelectPricing"
      :tiered-pricings-native="tieredPricingsNative"
      :current-table-rows="currentTableRows"
      :updateRowData="updateRowData"
      :saveHandler="saveHandler"
      :Model="Model"
      :Brand="Brand"
      :StandardPriceStart="StandardPriceStart"
      :StandardPriceEnd="StandardPriceEnd"
      :StepPlanGuid="StepPlanGuid"
      :IsUnUsual="IsUnUsual"
      :getIsInvoice="getIsInvoice"
    ></select-pricing>
    <common-problems :visible.sync="showCommonProblems"></common-problems>
    <bulk-pricing
      :visible.sync="showBulkPricing"
      :success-handler="onBindData"
    ></bulk-pricing>
    <BatchSettingBoolean
      :visible.sync="showBatchSettingBoolean"
      :BatchSettingBooleanConfig="BatchSettingBooleanConfig"
      :saveHandler="saveHandler"
      :onBindData="onBindData"
      :Model="Model"
      :Brand="Brand"
      :StandardPriceStart="StandardPriceStart"
      :StandardPriceEnd="StandardPriceEnd"
      :StepPlanGuid="StepPlanGuid"
      :IsUnUsual="IsUnUsual"
      :getIsInvoice="getIsInvoice"
      @isShowBatchMPQ="showBatchMPQ = true"
    ></BatchSettingBoolean>
    <BatchMPQ
      :visible.sync="showBatchMPQ"
      :success-handler="onBindData"
    ></BatchMPQ>
  </page-layout>
</template>
<script>
import { columns } from './columns';
import { NumToCharacters } from '../PricingStrategy/columns';
import SelectPricing from './SelectPricing';
import CommonProblems from './CommonProblems';
import { httpPost, httpGet } from '../../assets/scripts/http';
import PageLayout from '../PageLayout';
import TradingStore from '../../store';
import BulkPricing from './BulkPricing';
import BatchSettingBoolean from './BatchSettingBoolean';
import BatchMPQ from './BatchMPQ';
import './ColumnRender.js';
export default {
  name: '',
  created() {
    this.getShareStepPlanListAsync().then(() => {
      this.onInit();
    });
    if (
      this.store.state.route &&
      this.store.state.route.params &&
      this.store.state.route.params.StepPlanGuid
    ) {
      this.StepPlanGuid = this.store.state.route.params.StepPlanGuid;
    }
    this.getIeActionList();
    this.getUnUsualCount();
  },
  props: {
    managingInventoryHandler: Function
  },
  components: {
    SelectPricing,
    CommonProblems,
    PageLayout,
    BulkPricing,
    BatchSettingBoolean,
    BatchMPQ
  },
  data() {
    return {
      printznlbtns: [
        {
          name: '批量定价',
          iconName: '',
          click: () => {
            this.showBulkPricing = true;
          }
        },
        {
          name: '设置MPQ',
          iconName: '',
          click: () => {
            // this.batchHandler('MPQQty');
            this.showBatchMPQ = true;
          }
        },
        {
          name: '设置整包出售',
          iconName: '',
          click: () => {
            this.batchHandler('IsWholePackage');
          }
        },
        {
          name: '设置阶梯价方案',
          click: () => {
            this.changePlan();
          }
        },
        {
          name: '设置是否可开票',
          iconName: '',
          click: () => {
            this.batchHandler('IsInvoice');
          }
        }
      ],
      store: TradingStore,
      tieredPricings: [],
      IsInvoiceOptions: [
        { key: 13, value: '可开票 13%' },
        { key: 3, value: '可开票 3%' },
        { key: 0, value: '不可开票' }
      ],
      tieredPricingsNative: [],
      loading: false,
      datas: [],
      columns: [],
      totalCount: 1,
      pageSize: 20,
      pageIndex: 1,
      Model: '',
      Brand: '',
      StandardPriceStart: '',
      StandardPriceEnd: '',
      StepPlanGuid: '',
      showSelectPricing: false,
      currentTableRows: [],
      showCommonProblems: false,
      showBulkPricing: false,
      IsUnUsual: false,
      TaxRate: null,
      OrderBy: '',
      showBatchSettingBoolean: false,
      BatchSettingBooleanConfig: {
        type: '',
        SelectedRows: []
      },
      showBatchMPQ: false,
      showPricingMessage: false,
      showMessageBtn: true,
      UnUsualCount: 0
    };
  },
  methods: {
    getUnUsualCount() {
      httpPost('shareStock/getMySharePriceStockUnUsualCountAsync', {
        Model: this.Model,
        Brand: this.Brand,
        StandardPriceStart: this.StandardPriceStart,
        StandardPriceEnd: this.StandardPriceEnd,
        StepPlanGuid: this.StepPlanGuid,
        IsUnUsual: this.IsUnUsual,
        TaxRate: this.TaxRate,
        OrderBy: this.OrderBy
      }).then(res => {
        if (res.Code === 0) {
          this.UnUsualCount = res.Data;
        }
      });
    },
    async onInit() {
      // const vm = this;
      // 整包出售
      const IsWholePackageColumn = columns.find(
        item => item.field === 'IsWholePackage'
      );
      if (IsWholePackageColumn) {
        IsWholePackageColumn.cellRendererFramework = 'CheckedBoxRender';
        IsWholePackageColumn.cellRendererParams = {
          updateRowData: this.updateRowData,
          field: 'IsWholePackage'
        };
      }
      // MPQ
      const MPQQtyColumn = columns.find(item => item.field === 'MPQQty');
      if (MPQQtyColumn) {
        MPQQtyColumn.headerComponentFramework = 'GridHeaderSortRender';
        MPQQtyColumn.headerComponentParams = {
          vm: this,
          field: 'MPQQty'
        };
      }

      // 未税价
      const UntaxedPriceColumn = columns.find(
        item => item.field === 'UntaxedPrice'
      );
      if (UntaxedPriceColumn) {
        UntaxedPriceColumn.headerComponentFramework = 'GridHeaderSortRender';
        UntaxedPriceColumn.headerComponentParams = {
          vm: this,
          field: 'StandardPrice'
        };
      }

      // // 结算价
      const StandardPriceColumn = columns.find(
        item => item.field === 'SettlementPrice'
      );
      if (StandardPriceColumn) {
        StandardPriceColumn.cellRendererFramework = 'StandardPricesRender';
        StandardPriceColumn.cellRendererParams = {
          vm: this
        };
      }
      // 阶梯价方案
      const StepPlanGuidColumn = columns.find(
        item => item.field === 'StepPlanGuid'
      );
      if (StepPlanGuidColumn) {
        StepPlanGuidColumn.cellRendererFramework = 'StepPlanGuidRender';
        StepPlanGuidColumn.cellRendererParams = {
          vm: this
        };
      }
      // 状态
      const StautsColumn = columns.find(item => item.field === 'Stauts');
      if (StautsColumn) {
        StautsColumn.cellRendererFramework = 'StautsRender';
      }
      this.$refs.grid.changeColumns(columns);
      return this.onBindData();
    },
    onBindData(PageIndex = 1) {
      this.loading = true;
      httpPost('shareStock/getMySharePriceStockListAsync', {
        PageIndex,
        PageSize: this.pageSize,
        Model: this.Model,
        Brand: this.Brand,
        StandardPriceStart: this.StandardPriceStart,
        StandardPriceEnd: this.StandardPriceEnd,
        StepPlanGuid: this.StepPlanGuid,
        IsUnUsual: this.IsUnUsual,
        TaxRate: this.TaxRate,
        OrderBy: this.OrderBy
      })
        .then(res => {
          this.loading = false;
          if (res.Code === 0) {
            const Datas = res.Data.ResultList || [];
            Datas.forEach(item => {
              item.NewStepPrices = [];
              item.NewStepPricesLessThan20 = [];
            });
            this.$refs.grid.setRowData(Datas);
            this.pageIndex = res.Data.PageIndex;
            this.totalCount = res.Data.TotalCount;
          }
        })
        .catch(() => {
          this.loading = false;
        });
      this.getUnUsualCount();
    },
    batchHandler(type) {
      const SelectedRows = this.$refs.grid.getSelectedRows();
      this.showBatchSettingBoolean = true;
      this.BatchSettingBooleanConfig = {
        type,
        SelectedRows
      };
    },
    updateRowData(row) {
      return this.$refs.grid.updateRowData(row);
    },
    managingInventory() {
      if (this.managingInventoryHandler) {
        this.managingInventoryHandler();
      }
    },
    changeHandler(value) {
      if (value && value.key) {
        this.StepPlanGuid = value.key;
      } else {
        this.StepPlanGuid = '';
      }
      this.onBindData();
    },
    IsInvoicechangeHandler(value) {
      if (value && typeof value.key !== 'undefined') {
        this.TaxRate = value.key;
      } else {
        this.TaxRate = null;
      }
      this.onBindData();
    },
    // 获取方案列表
    getShareStepPlanListAsync() {
      return httpGet('shareStock/getShareStepPlanListAsync').then(res => {
        if (res.Code === 0) {
          const Datas = res.Data || [];
          this.tieredPricingsNative = Datas;
          this.tieredPricings = Datas.map(item => {
            return {
              value: `方案${NumToCharacters(item.StepPlanId)}`,
              key: item.StepPlanGuid
            };
          });
        }
        return res;
      });
    },
    clearParamsHandler() {
      this.Model = '';
      this.Brand = '';
      this.StandardPriceStart = '';
      this.StandardPriceEnd = '';
      this.StepPlanGuid = '';
      this.$refs.selectinput.clear();
      this.$refs.selectinput1.clear();
      this.onBindData();
    },
    saveHandler(Datas) {
      const changesData = Datas ? Datas : this.$refs.grid.getUpdatedDatas();
      if (changesData.length > 0) {
        this.loading = true;

        httpPost('shareStock/saveSharePricesAsync', changesData)
          .then(res => {
            this.loading = false;
            if (res && res.Code === 0 && res.Data) {
              this.onBindData();
              this.$succMess('保存成功');
            } else {
              this.$erroMess(res.Message);
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.$erroMess('没有数据修改');
      }
    },
    changePlan() {
      const rows = this.$refs.grid.getSelectedRows();
      if (rows.length === 0) {
        this.$confirm(
          '按当前搜索条件批量修改全部数据，是否确定修改？',
          '提醒',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }
        ).then(() => {
          this.currentTableRows = rows;
          this.showSelectPricing = true;
        });
      } else {
        this.currentTableRows = rows;
        this.showSelectPricing = true;
      }
    },
    getIsInvoice() {
      return this.TaxRate;
    },
    openMessage() {
      const vm = this;
      const h = this.$createElement;
      this.$msgbox({
        title: '定价规则调整通知',
        message: h('p', null, [
          h(
            'span',
            null,
            '原“标准价(含税)”已扣除13%税点后调整为“未税价”，后续定价请使用未税价导入，请周知。'
          ),
          vm.showMessageBtn &&
            h(
              'el-checkbox',
              {
                class: 'pull-right',
                on: {
                  change(value) {
                    vm.showPricingMessage = value;
                  }
                }
              },
              '设为已读'
            )
        ]),
        showCancelButton: false,
        confirmButtonText: '确定'
      }).then(() => {
        vm.setIeActionList();
      });
    },
    getIeActionList() {
      httpGet('mmieaction/GetIeActionList').then(data => {
        if (data.Code === 0) {
          const tipvisibleObject = data.Data.find(item => {
            return item.Key === 'showPricingMessage';
          });
          if (
            !tipvisibleObject ||
            tipvisibleObject.showPricingMessage === 'false'
          ) {
            this.openMessage();
            this.showMessageBtn = true;
          } else {
            this.showMessageBtn = false;
          }
        }
      });
    },
    setIeActionList() {
      if (!this.showPricingMessage) {
        return;
      }
      const params = {
        key: 'showPricingMessage',
        value: this.showPricingMessage
      };
      httpPost('mmieaction/SaveUpdate', params).then(response => {
        if (response.Code === 0) {
          return null;
        }
      });
    },
    onCellValueChanged(params) {
      if (params.colDef.field === 'TaxRate') {
        params.data.SettlementPrice =
          Math.round(
            params.data.UntaxedPrice * (params.data.TaxRate / 100 + 1) * 10000
          ) / 10000;
        this.updateRowData(params.data);
      }
    }
  }
};
</script>
<style lang="scss">
$--header-height: 50px;
$--input-height: 28px;
.p-InventoryPricing {
  font-size: 12px;
  .c-tradingcenter-search-header {
    .znl-btn-select {
      .icon-arrow_unfold_btn,
      .icon-arrow_up_btn {
        font-size: 16px;
      }
    }
  }
  .header-title_tips {
    font-size: 12px;
    cursor: pointer;
    margin-left: 3px;
  }
  .header-marginleft {
    margin-left: 5px;
  }
  .input-center-text {
    margin: 0 5px;
  }
  .el-checkbox__label {
    font-size: 12px;
  }
  .icon-abnormal_ic {
    color: #ff2200;
    font-size: 14px;
    font-weight: bold;
    margin-left: 5px;
  }
  .smart-solution {
    cursor: pointer;
    &:hover {
      color: #ee7700;
      font-weight: bold;
    }
    .iconfont {
      position: absolute;
      top: 0px;
      right: 3px;
      color: #999;
      font-size: 16px;
    }
  }
  .znl-btn-text.default .button {
    text-decoration: none;
  }
  .line-through {
    text-decoration: line-through;
    color: #ccc;
    outline: none;
    &:hover {
      color: #ccc;
    }
    &.znl-btn-text.default .button {
      color: #ccc;
    }
  }
  .znl-is-read-only {
    background-color: #fff;
    .cell-background-f5f5f5 {
      background-color: #f5f5f5;
    }
  }
  .el-table__body tr.current-row > td {
    .cell-background-f5f5f5 {
      background-color: #d1f0ff;
    }
  }
  .onlyabnormal {
    position: relative;
  }
  .header-mpq {
    cursor: pointer;
    position: relative;
    left: 3px;
    line-height: 28px;
  }
  .header-mpq-title {
    position: relative;
    display: inline-block;
    height: 28px;
    vertical-align: bottom;
  }
  .wj-right-menu ul li a:hover,
  .wj-right-menu ul li span:hover {
    background-color: #ed9e00;
    color: #fff !important;
  }
  .header-mpq-icon {
    position: relative;
    display: inline-block;
    width: 12px;
    height: 28px;
    vertical-align: bottom;
    .iconfont {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 12px;
      color: #ccc;
      &.active {
        color: #ee7700;
      }
    }
    .icon-up {
      top: -2px;
    }
    .icon-xiala {
      top: 3px;
    }
  }
  .p-InventoryPricing-grid-container {
    height: 600px;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #606266;
  }
  .CheckedBoxRender-select {
    .el-select .el-input__inner {
      padding-right: 5px;
      font-size: 12px;
      padding-left: 5px;
      border: none;
      background-color: transparent;
    }
    .el-select .el-input .el-select__caret {
      width: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #fff;
    &::after {
      border-color: #ee7700;
    }
  }
}
.c-InventoryPricing-popover {
  padding: 0;
  overflow: hidden;
  padding: 0 10px;
  box-sizing: border-box;
  text-align: center;
  li {
    line-height: 26px;
    &.title {
      font-size: 14px;
      font-weight: bold;
      justify-content: center;
    }
    &.li-row {
      font-size: 12px;
      padding-left: 5px;
      position: relative;
      color: #000;
      &::before {
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 50%;
        position: absolute;
        left: -2px;
        top: 11px;
        background-color: #333;
      }
    }
  }
  .tip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 18px;
  }
  .final-price {
    display: flex;
    font-size: 12px;
    line-height: 26px;
    &.title {
      font-size: 12px;
    }
    span {
      width: 50%;
    }
    .row-span {
      box-sizing: border-box;
      &:first-child {
        text-align: right;
        padding-right: 10px;
      }
      &:last-child {
        text-align: left;
        padding-left: 10px;
      }
    }
  }
  .LessThan20 {
    border-bottom: 1px dashed #ee7700;
    span {
      text-decoration: line-through;
    }
  }
}
</style>
